class ItemDataParser {

  fixItemPath(path) {
    //hacky logic to ensure we can always look up the item
    let pathPrefix = '/sitecore/content';
    if (path === "/") {
      //assume sitecore content home
      return pathPrefix + "/home";
    }
    return pathPrefix + '/home/' + path;
  }

  mapContentItemToResult(itemData) {
    //reduce the data to what we use.
    //Note: this is probably goin to be more ceremony than is necessary yet I want to see what we actually use from the conten item.
    let result =
    {
      id: itemData.ItemID,
      name: itemData.ItemName,
      path: itemData.ItemPath,
      language: itemData.ItemLanguage,
      version: itemData.ItemVersion,
      templateName: itemData.TemplateName,
      personalizationDetails: this.getPersonalizationDetails(itemData),
      trackingDetails: this.getTrackingDetails(itemData),
      owner: itemData.__Owner,
      createdBy: itemData["__Created by"],
      createdOn: itemData["__Created"],
      lastUpdatedBy: itemData["__Updated by"],
      lastUpdated: itemData["__Updated"]
    }
    return result;
  }

  getPersonalizationRulesets(xml) {
    let xmldoc = new DOMParser().parseFromString(xml, 'application/xml');
    let results = xmldoc.evaluate("//ruleset/rule", xmldoc, null, XPathResult.ORDERED_NODE_ITERATOR_TYPE, null);

    let rules = [];
    let rule;

    while (rule = results.iterateNext()) {

      let conditions = xmldoc.evaluate("conditions/condition", rule, null, XPathResult.ORDERED_NODE_ITERATOR_TYPE, null);
      let condition;
      let conditionList = [];
      while (condition = conditions.iterateNext()) {

        let cattr = condition.getAttributeNames();
        conditionList.push({
          uid: condition.getAttribute("uid"),
          id: condition.getAttribute("s:id"),
          operatorId: condition.getAttribute("s:operatorId"),
          allAttributes: cattr.map(attr => {
            return {
              attribute: attr,
              value: condition.getAttribute(attr)
            };
          })
        })
      }

      let actions = xmldoc.evaluate("actions/action", rule, null, XPathResult.ORDERED_NODE_ITERATOR_TYPE, null);
      let action;
      let actionList = [];
      while (action = actions.iterateNext()) {

        let aattr = action.getAttributeNames();

        actionList.push({
          uid: action.getAttribute("uid"),
          id: action.getAttribute("s:id"),
          datasourceId: action.getAttribute("s:DataSource"),
          allAttributes: aattr.map(attr => {
            return {
              attribute: attr,
              value: action.getAttribute(attr)
            }
          })
        });
      }

      //TODO convert this to group the rules under the rendering after video recording.
      //.parent.parent.parent = <r> tag //TODO: perhaps refactor this to start at //r rather than traverse backwards so it's easier to read
      let renderingElement = rule.parentElement.parentElement.parentElement;

      rules.push({
        renderingId: renderingElement.getAttribute("id"),
        renderingPlaceholderKey: renderingElement.getAttribute("ph"),
        uid: rule.getAttribute("uid"),
        name: rule.getAttribute("s:name"),
        conditions: conditionList,
        actions: actionList
      });
    }
    return rules;
  }

  //determines if the specified node is the default condition used by sitecore
  hasAtleastOnePersonalizationCondition(rules) {

    return rules.filter(r => r.uid != '{00000000-0000-0000-0000-000000000000}').length > 0;
  }

  getPersonalizationDetails(itemData) {

    let result =
    {
      isUsingPersonalization: false
    };

    let renderingRulesets = this.getPersonalizationRulesets(itemData["__Renderings"]);
    let finalRenderingRulesets = this.getPersonalizationRulesets(itemData["__Final Renderings"]);

    result.isUsingPersonalization = this.hasAtleastOnePersonalizationCondition(renderingRulesets) || this.hasAtleastOnePersonalizationCondition(finalRenderingRulesets);

    //TODO: need to merge these two
    result.renderingRulesets = renderingRulesets;
    result.finalRenderingRulesets = finalRenderingRulesets;

    return result;
  }

  getTrackingDetails(itemData) {
    let xml = itemData.__Tracking;

    let result =
    {
      expectedProfileCard: ""
    };

    if (xml === '') {
      return result;
    }

    let xmldoc = new DOMParser().parseFromString(xml, 'application/xml');

    //TODO
    //let results = xmldoc.evaluate("TODO",xmldoc, null, XPathResult.ORDERED_NODE_ITERATOR_TYPE, null);

    return result;

  }

  getRemovedRulesets(pv, nv) {
    let result = [];

    pv.personalizationDetails.renderingRulesets.forEach(oldruleset => {
      let match = nv.personalizationDetails.renderingRulesets.find(r => r.uid === oldruleset.uid)
      //not found in the new one. it was removed
      if (match === undefined) {
        result.push(oldruleset);
      }
    });

    return result;
  }

  getNewRulesets(pv, nv) {
    let result = [];

    nv.personalizationDetails.renderingRulesets.forEach(newruleset => {
      let match = pv.personalizationDetails.renderingRulesets.find(r => r.uid === newruleset.uid);

      //if not in the old one, it was added
      if (match === undefined) {
        result.push(newruleset)
      }
    });

    return result;
  }

  //creates a an array of change history, including changes from one version to the next
  createChangeHistory(itemVersionHistory) {
    let results = [];
    let previousVersion = null;

    itemVersionHistory.forEach((e) => {

      let itemVersion = this.mapContentItemToResult(e);

      itemVersion.changes = {};
      if (null !== previousVersion) {
        // get personalization changes
        //append changeset to the item  
        itemVersion.changes = {
          newRulesets: this.getNewRulesets(previousVersion, itemVersion),
          removedRulesets: this.getRemovedRulesets(previousVersion, itemVersion)
        }
      }

      results.push(itemVersion);
      previousVersion = itemVersion;

    });

    return results;
  }
}

export default new ItemDataParser();



// WEBPACK FOOTER //
// ./src/data/ItemDataParser.js